module.exports = {
    cloud_front : `//d287nhi7bqyj2m.cloudfront.net`
}